import { breakpoints } from '@/hooks/useBreakpoint';

export function getCardsCountInRow(pageWidth: number) {
  switch (true) {
    case pageWidth <= breakpoints.sm:
      return 2;
    case pageWidth <= breakpoints.lg:
      return 3;
    case pageWidth > breakpoints.lg:
      return 4;

    default:
      return 2;
  }
}
